import { GameController } from "../../../../controllers/GameController";
import { GameResourcesPackage } from "../../../../resources/GameResourcesPackage";
import { AudioController } from "../../../AudioController";
import { Character } from "../../character/Character";
import { IProjectileContainer } from "../IProjectileContainer";
import { BaseMole } from "./BaseMole";
import { AttackState } from "./states/AttackState";
import { DieState } from "./states/DieState";
import { DigInState } from "./states/DigInState";
import { DigOutState } from "./states/DigOutState";
import { EatingState } from "./states/EatingState";
import { FreezeState } from "./states/FreezeState";
import { IdleTimeoutState } from "./states/IdleTimeoutState";
import { Vegetable } from "../Vegetable";
import { BatchedRenderer } from "three.quarks";
import { IdleToRepeatState } from "./states/IdleToRepeatState";

export class AggressiveEaterMole extends BaseMole {
    public constructor(
        gameResources: GameResourcesPackage,
        projectileContainer: IProjectileContainer,
        particlesRenderer: BatchedRenderer,
        character: Character,
        vegetable: Vegetable,
        audioController: AudioController,
        gameController: GameController,
        fieldIndex: number
    ) {
        super(
            fieldIndex,
            gameResources,
            projectileContainer,
            particlesRenderer,
            character,
            audioController,
            gameController,
            200
        );
        const dieState = new DieState(this, this.animationController);
        const freezeState = new FreezeState(gameResources, particlesRenderer, this, this.animationController, dieState);
        const digInState = new DigInState(this, this.animationController, dieState, freezeState);
        const idleAfterEatState = new IdleToRepeatState(this, this.animationController, dieState, freezeState, this.randomIdleAnimationTimeout());
        const eatState = new EatingState(this, this.animationController, idleAfterEatState, digInState, dieState, freezeState, vegetable, audioController);
        const idleAfterAttackState = new IdleTimeoutState(this, this.animationController, eatState, dieState, freezeState, 3000);
        const attackState = new AttackState(this, this.animationController, idleAfterAttackState, dieState, freezeState, 1);
        const idleBeforeAttackState = new IdleTimeoutState(this, this.animationController, attackState, dieState, freezeState, 3000);
        const digOutState = new DigOutState(this, this.animationController, idleBeforeAttackState, dieState, freezeState);
        this.switchState(digOutState);
    }
}